import * as initialDataTypes from '../types/InitialData';
import * as utilActions from './Util';

export function getInitialData() {
    return async (dispatch) => {
        try {
            dispatch(getInitialDataRequest());
            await dispatch(utilActions.getCouriers());
            await dispatch(utilActions.getCustomersTypesDictionary());
            await dispatch(utilActions.getQuantityCorrectionsProposalsDictionary());
            await dispatch(utilActions.getTermOfUseURL());
            await dispatch(utilActions.getAllowMultiplePositionsForComplaintSetting());
            await dispatch(utilActions.getIsMyCompanyNotFoundCheckBoxVisibleSetting());
            await dispatch(utilActions.getIsSerialNumberTooltipVisibleSetting());
            dispatch(getInitialDataSuccess());
        } catch (error) {
            getInitialDataError({message:"Wystąpił błąd podczas pobierania początkowych danych", title:"Wystąpił błąd"});
        }
    };
}

export function getInitialDataError(error) {
    return {
        type: initialDataTypes.GET_INITIAL_DATA_FAILURE,
        error: error
    };
}

export function getInitialDataRequest() {
    return {
        type: initialDataTypes.GET_INITIAL_DATA_REQUEST
    };
}

export function getInitialDataSuccess() {
    return {
        type: initialDataTypes.GET_INITIAL_DATA_SUCCESS
    };
}




// WEBPACK FOOTER //
// ./src/actions/InitialData.js